import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import ClickAwayListener from '@mui/material/ClickAwayListener';


function getStyles(value, selectedValue, theme) {
  const selectedValues = Array.isArray(selectedValue) ? selectedValue : [selectedValue];
  return {
    fontWeight:
    selectedValues.indexOf(value) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

export default function MultipleSelect({list, defaultValue, label, width, multiple, onSelectedValue, resetSelection}) {



const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 5;
const MenuProps = {
  disableScrollLock: true,
  sx: {
    pointerEvents: "none",
  },
  PaperProps: {
    sx: {
      pointerEvents: "auto",
    },
    style: { 
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 200,
    },
  },
};
 

  const theme = useTheme();
  const [selectedValue, setSelectedValue] = React.useState(multiple ? [] : "");
  const [open, setOpen] = React.useState(false);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setSelectedValue(
      multiple
        ? (typeof value === 'string' ? value.split(',') : value)
        : value
    );

    onSelectedValue(value)
  };



  React.useEffect(() => { 
    if (defaultValue !== undefined ) {
      setSelectedValue(multiple ? [defaultValue] : defaultValue)
    }

  }, [defaultValue, multiple])


  React.useEffect(() => { 
    
      setSelectedValue(multiple ? [] : "") 

  }, [multiple, resetSelection])

  return (
    
      <ClickAwayListener onClickAway={() => setOpen(false)}>
      <FormControl sx={{  width: width ? width : "100%"}}>
        <InputLabel id="demo-multiple-item-label" >{label}</InputLabel>
        <Select
            labelId="demo-multiple-item-label"
            id="demo-multiple-item"
            multiple={multiple}
            value={selectedValue} 
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            onChange={handleChange}
            input={<OutlinedInput label={label} />}
            sx={{height: ITEM_HEIGHT }}
            MenuProps={MenuProps}
        >
          {list.map((item) => (
            <MenuItem
              key={item}
              value={item}
              style={getStyles(item, selectedValue, theme)}
            >
              {item}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      </ClickAwayListener>
    
  );
}
